import React from 'react';
import util from 'Utils/commonUtil';

// Components
import Input from 'Components/common/Input';
import Anchor from 'Components/common/Anchor';

// Icons
import {Search} from '@material-ui/icons';

// Actions
import {T} from 'Actions/translate';

class SearchInput extends React.Component {
    getInputOtherProps = () => {
        let props = {...this.props};
        let classNameList = ['search-input'];

        if (util.isString(props.className)) {
            classNameList = ['search-input', ...props.className.split(' ')];
        }
        props.className = classNameList.join(' ');

        if (props.options && util.isBoolean(props.options.loadedFocus)) {
            props.loadedFocus = props.options.loadedFocus;
        }
        delete props.options;
        delete props.search;

        return props;
    };

    onSubmit = (ev) => {
        if (ev.target && ev.target.tagName === 'FORM') {
            ev.target.getElementsByTagName('input')[0].blur();
            ev.preventDefault();
        }
        if (util.isFunction(this.props.search)) this.props.search();
    };

    render() {
        const options = this.props.options || {};
        const iconClassNameList = util.isString(
            options && options.iconClassName,
        )
            ? ['search-icon', ...options.iconClassName.split(' ')]
            : ['search-icon'];
        const searchBtnClassNameList = util.isString(
            options && options.searchBtnClassName,
        )
            ? ['search-link', ...options.searchBtnClassName.split(' ')]
            : ['search-link'];
        const searchText = (options && options.searchText) || T('search');
        const {testid} = this.props;

        return (
            <form className="search-input-container" onSubmit={this.onSubmit}>
                <div className="search-input-box">
                    <div className={iconClassNameList.join(' ')}>
                        <Search testid={testid ? testid + '-icon' : ''} />
                    </div>
                    <Input
                        testid={testid ? testid : ''}
                        ref="input"
                        {...this.getInputOtherProps()}
                    />
                </div>
                {options.hideSearchBtn ? null : (
                    <Anchor
                        className={searchBtnClassNameList.join(' ')}
                        testid={testid ? `${testid}-search-btn` : ''}
                        onClickOfSingleTap={this.onSubmit}>
                        {searchText}
                    </Anchor>
                )}
            </form>
        );
    }
}

export default SearchInput;
